import { render, staticRenderFns } from "./CandidateHeader.vue?vue&type=template&id=c2147892&scoped=true"
import script from "./CandidateHeader.vue?vue&type=script&lang=js"
export * from "./CandidateHeader.vue?vue&type=script&lang=js"
import style0 from "./CandidateHeader.vue?vue&type=style&index=0&id=c2147892&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2147892",
  null
  
)

export default component.exports